import { render, staticRenderFns } from "./ShowImageDialog.vue?vue&type=template&id=54080502&scoped=true&"
import script from "./ShowImageDialog.vue?vue&type=script&lang=js&"
export * from "./ShowImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShowImageDialog.vue?vue&type=style&index=0&id=54080502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54080502",
  null
  
)

export default component.exports